<template>
  <div class="location-bd" v-if="funcView.location_list">
    <div class="search-hd  clear">
      <!-- <div class="title-hd">
        <i class="icon icon-gongsi"></i>
        {{ userInfo.rootOrgName }}
      </div> -->
      <el-form :inline="true" @submit.native.prevent class="form-screen">
        <el-form-item v-if="funcView.location_add">
          <el-button class="custom-btn" icon="icon icon-tianjia left-icon" type="warning" round @click="addLocation" >{{ $t('Common.com_location') }}</el-button>
        </el-form-item>
        <el-form-item v-if="funcView.location_update_targets">
          <el-button  :disabled="!hasBasicGoal" type="warning" @click="onUpdateTargets()">{{ $t('location.gxzdmb') }}</el-button>
        </el-form-item>
        <el-form-item v-if="funcView.project_update_timeZone &&timeZoneList.length>1">
          <el-button :disabled="!this.tableSelect.length" type="warning" @click="onUpdateTimeZone()">{{ $t('location.tbxmsq') }}</el-button>
        </el-form-item>
        <el-form-item v-if="funcView.location_enable_target_autoset">
          <el-button :disabled="!hasNoBasicGoa"  type="warning" @click="onEnableTargets()">{{ $t('location.qymbzdsz') }}</el-button>
        </el-form-item>
        <el-form-item v-if="funcView.location_disable_target_autoset">
          <el-button :disabled="!hasBasicGoal" type="warning" @click="onDisableTargets()">{{ $t('location.jymbzdsz') }}</el-button>
        </el-form-item>
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <i class="icon icon-shaixuan icon-filter" @click="isFilter = !isFilter"></i>
        </el-form-item>
        <el-form-item
          style="float: right"
          v-if="funcView.location_export"
        >
          <el-button
            type="info"
            @click="onExport"
          >
            <i class="icon icon-export-excel"></i>
            {{ $t('Common.com_export') }} Excel
          </el-button>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('Common.com_location_name')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
      </el-form>
      <div class="query-filter" v-show="isFilter">
        <div class="params-form">
          <el-row :gutter="23">
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('location.gong_si_ming_cheng') }}</div>
                <div class="value">
                  <el-input v-model="formSearch.orgName" clearable @input="onPageChange({ page: 1 })" style="width: 100%"></el-input>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('Common.com_belong_to_department') }}</div>
                <div class="value">
                  <custom-select
                    url="DepartmentTree"
                    v-model="formSearch.departmentId"
                    :model="formSearch"
                    :props="{ label: 'bizName', value: 'bizId',checkStrictly: true,map: { bizName: 'departmentName' } }"
                    :params="{ isCountDevice:1 }"
                    :placeholder="$t('Common.com_please_select')"
                    width="100%"
                    ref="tag"
                    type="tree"
                    filterable
                    :dataFilter="departmentTreeFilter"
                    @treeValChange="onPageChange({ page: 1 })"
                    @treeValChangeLabel="onDepartmentLabel"
                    @getList="onDepartmentList"
                    :clearable="false"
                  ></custom-select>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('location.fu_ze_ren') }}</div>
                <div class="value">
                  <el-input v-model="formSearch.contactName" clearable @input="onPageChange({ page: 1 })" style="width: 100%"></el-input>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="filter-values">
          <div class="label">{{ $t('Common.com_filter_item') }}</div>
          <div class="values">
            <el-tag
              v-if="formSearch.orgName "
              closable
              @close="
                formSearch.orgName  = '';
                onPageChange({ page: 1 });
              "
            >
              {{ formSearch.orgName  }}
            </el-tag>
            <el-tag
              v-if="formSearch.departmentId"
              closable
              @close="
                formSearch.departmentId = '';
                formSearch.departmentName = '';
                onPageChange({ page: 1 });
              "
            >
              {{ formSearch.departmentName }}
            </el-tag>
            <el-tag
            v-if="formSearch.contactName"
            closable
            @close="
              formSearch.contactName = '';
              onPageChange({ page: 1 });
            "
          >
            {{ formSearch.contactName }}
          </el-tag>
            <span
              class="clear"
              @click="onClear"
            >{{ $t('Common.com_clear') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div style="border-radius: 16px;margin-top: 16px;padding: 24px 24px 0; background: #fff;">
      <div class="table-bd">
        <!-- 美国站是ft² -->
        <custom-table
          v-if="isUs"
          tableCode="portal_location_ft"
          :stripe="true"
          type="checkbox"
          v-model="tableSelect"
          @column="setColumn"
          height="100%"
          :index="true"
          :data="tableList"
          @sort="sortChange"
          @filter="filterChange"
          @expand-change="onRowClick"
          :slots="['deviceNum', 'goalArea','goalTime','detailAddress', 'action']"
          :filterArr="timeZoneList.length>1?[]:['timeZoneRegionDesc']"
        >
          <template v-slot:deviceNum="scope">
            <span class="cell-link" v-if="+scope.row.deviceNum>0"  @click="jump('/other/distribution', { active: 'location', locationId: scope.row.locationId })">{{ scope.row.deviceNum }}</span>
            <span v-else type="text">{{ scope.row.deviceNum }}</span>
          </template>
          <template v-slot:goalArea="scope">
            <el-popover placement="bottom" width="840" trigger="hover" v-if="+scope.row.goalArea>0&&+scope.row.isBasicGoal === 1&&scope.row.basicGoalDetailList">
              <el-table :data="scope.row.basicGoalDetailList" :summary-method="summaryMethod" show-summary>
                <el-table-column width="100" property="productCode" :label="$t('location.chan_pin_xing_hao')"></el-table-column>
                <el-table-column width="100" property="deviceNum" :label="$t('location.she_bei_shu_liang')"></el-table-column>
                <el-table-column width="150" property="basicArea" :label="$t('location.dtqjmjftt')">
                  <template slot-scope="scope">
                    <span size="mini">{{+scope.row.basicArea>0?formatNumber(($formatLenLocal(+scope.row.basicArea)).toFixed(2)):0}}</span>
                  </template>
                </el-table-column>
                <el-table-column width="150" property="basicTime" :label="$t('location.dtqjscmint')"></el-table-column>
                <el-table-column width="150" property="totalGoalArea" :label="$t('location.hjqjmjftt')">
                  <template slot-scope="scope">
                    <span size="mini">{{+scope.row.basicArea>0?formatNumber((+scope.row.deviceNum * $formatLenLocal(+scope.row.basicArea)).toFixed(2)):0}}</span>
                  </template>
                </el-table-column>
                <el-table-column width="150" property="totalGoalTime" :label="$t('location.xjqjscmint')">
                  <template slot-scope="scope">
                    <span size="mini">{{( +scope.row.basicTime>0?formatNumber((+scope.row.deviceNum * +scope.row.basicTime).toFixed(2)):0)}}</span>
                  </template>
                </el-table-column>
              </el-table>
              <span slot="reference" class="cell-link">{{ $formatLenLocal(scope.row.goalArea) }}</span>
            </el-popover>
            <span  v-else >{{$formatLenLocal(scope.row.goalArea)}}</span>
          </template>
          <template v-slot:goalTime="scope">
            <el-popover placement="bottom" width="840" trigger="hover" v-if="+scope.row.goalTime>0&&+scope.row.isBasicGoal === 1&&scope.row.basicGoalDetailList">
              <el-table :data="scope.row.basicGoalDetailList" :summary-method="summaryMethod" show-summary>
                <el-table-column width="100" property="productCode" :label="$t('location.chan_pin_xing_hao')"></el-table-column>
                <el-table-column width="100" property="deviceNum" :label="$t('location.she_bei_shu_liang')"></el-table-column>
                <el-table-column width="150" property="basicArea" :label="$t('location.dtqjmjftt')">
                  <template slot-scope="scope">
                    <span size="mini">{{+scope.row.basicArea>0?formatNumber(($formatLenLocal(+scope.row.basicArea)).toFixed(2)):0}}</span>
                  </template>
                </el-table-column>
                <el-table-column width="150" property="basicTime" :label="$t('location.dtqjscmint')"></el-table-column>
                <el-table-column width="150" property="totalGoalArea" :label="$t('location.hjqjmjftt')">
                  <template slot-scope="scope">
                    <span size="mini">{{+scope.row.basicArea>0?formatNumber((+scope.row.deviceNum * $formatLenLocal(+scope.row.basicArea)).toFixed(2)):0}}</span>
                  </template>
                </el-table-column>
                <el-table-column width="150" property="totalGoalTime" :label="$t('location.xjqjscmint')">
                  <template slot-scope="scope">
                    <span size="mini">{{( +scope.row.basicTime>0?formatNumber((+scope.row.deviceNum * +scope.row.basicTime).toFixed(2)):0)}}</span>
                  </template>
                </el-table-column>
              </el-table>
              <span slot="reference" class="cell-link">{{ scope.row.goalTime }}</span>
            </el-popover>
            <span v-else >{{ scope.row.goalTime ||'-'}}</span>
          </template>
          <template v-slot:detailAddress="scope">{{ scope.row.country || '' }}{{ scope.row.province || '' }}{{ scope.row.city || '' }}{{ scope.row.detailAddress }}</template>
          <template v-slot:action="scope">
            <el-button type="text" size="mini" v-if="funcView.location_assign" @click.stop="jump('/other/distribution', { active: 'location', locationId: scope.row.locationId })">{{ $t('location.fen_pei_she_bei') }}</el-button>
            <el-button type="text" size="mini" v-if="funcView.location_plan_add" @click.stop="addPlan(scope.row)">{{ $t('location.pai_ban_ji_hua') }}</el-button>
            <el-button type="text" size="mini" v-if="funcView.location_edit" @click.stop="editLocation(scope.row)">{{ $t('Common.com_edit') }}</el-button>
            <el-button type="text" size="mini" v-if="funcView.location_delete && scope.row.deviceNum == 0" @click.stop="deleteLocation(scope.row)">{{ $t('Common.com_delete') }}</el-button>
          </template>
        </custom-table>

        <custom-table
          v-else
          expand
          type="checkbox"
          v-model="tableSelect"
          tableCode="portal_location"
          :stripe="true"
          @column="setColumn"
          height="100%"
          :data="tableList"
          @sort="sortChange"
          @filter="filterChange"
          @expand-change="onRowClick"
          :slots="['deviceNum', 'goalArea','goalTime','detailAddress', 'action']"
          :filterArr="timeZoneList.length>1?[]:['timeZoneRegionDesc']"
        >
          <template v-slot:deviceNum="scope">
            <span class="cell-link" v-if="+scope.row.deviceNum>0"  @click="jump('/other/distribution', { active: 'location', locationId: scope.row.locationId })">{{ scope.row.deviceNum }}</span>
            <span v-else type="text">{{ scope.row.deviceNum }}</span>
          </template>
          <template v-slot:goalArea="scope">
            <el-popover placement="bottom" width="840" trigger="hover" v-if="+scope.row.goalArea>0&&+scope.row.isBasicGoal === 1&&scope.row.basicGoalDetailList">
              <el-table :data="scope.row.basicGoalDetailList" :summary-method="summaryMethod" show-summary>
                <el-table-column width="100" property="productCode" :label="$t('location.chan_pin_xing_hao')"></el-table-column>
                <el-table-column width="100" property="deviceNum" :label="$t('location.she_bei_shu_liang')"></el-table-column>
                <el-table-column width="150" property="basicArea" :label="$t('location.dtqjmjmt')"></el-table-column>
                <el-table-column width="150" property="basicTime" :label="$t('location.dtqjscmint')"></el-table-column>
                <el-table-column width="150" property="totalGoalArea" :label="$t('location.hjqjmjmt')">
                  <template slot-scope="scope">
                    <span size="mini">{{+scope.row.basicArea>0?formatNumber((+scope.row.deviceNum * $formatLenLocal(+scope.row.basicArea)).toFixed(2)):0}}</span>
                  </template>
                </el-table-column>
                <el-table-column width="150" property="totalGoalTime" :label="$t('location.xjqjscmint')">
                  <template slot-scope="scope">
                    <span size="mini">{{( +scope.row.basicTime>0?formatNumber((+scope.row.deviceNum * +scope.row.basicTime).toFixed(2)):0)}}</span>
                  </template>
                </el-table-column>
              </el-table>
              <span slot="reference" class="cell-link">{{ $formatLenLocal(scope.row.goalArea) }}</span>
            </el-popover>
            <span  v-else >{{$formatLenLocal(scope.row.goalArea)}}</span>
          </template>
          <template v-slot:goalTime="scope">
            <el-popover placement="bottom" width="840" trigger="hover" v-if="+scope.row.goalTime>0&&+scope.row.isBasicGoal === 1&&scope.row.basicGoalDetailList">
              <el-table :data="scope.row.basicGoalDetailList" :summary-method="summaryMethod" show-summary>
                <el-table-column width="100" property="productCode" :label="$t('location.chan_pin_xing_hao')"></el-table-column>
                <el-table-column width="100" property="deviceNum" :label="$t('location.she_bei_shu_liang')"></el-table-column>
                <el-table-column width="150" property="basicArea" :label="$t('location.dtqjmjmt')"></el-table-column>
                <el-table-column width="150" property="basicTime" :label="$t('location.dtqjscmint')"></el-table-column>
                <el-table-column width="150" property="totalGoalArea" :label="$t('location.hjqjmjmt')">
                  <template slot-scope="scope">
                    <span size="mini">{{+scope.row.basicArea>0?formatNumber((+scope.row.deviceNum * $formatLenLocal(+scope.row.basicArea)).toFixed(2)):0}}</span>
                  </template>
                </el-table-column>
                <el-table-column width="150" property="totalGoalTime" :label="$t('location.xjqjscmint')">
                  <template slot-scope="scope">
                    <span size="mini">{{( +scope.row.basicTime>0?formatNumber((+scope.row.deviceNum * +scope.row.basicTime).toFixed(2)):0)}}</span>
                  </template>
                </el-table-column>
              </el-table>
              <span slot="reference" class="cell-link">{{ scope.row.goalTime }}</span>
            </el-popover>
            <span v-else >{{ scope.row.goalTime ||'-'}}</span>
          </template>
          <template v-slot:detailAddress="scope">{{ scope.row.country || '' }}{{ scope.row.province || '' }}{{ scope.row.city || '' }}{{ scope.row.detailAddress }}</template>
          <template v-slot:action="scope">
            <el-button type="text" size="mini" v-if="funcView.location_assign" @click.stop="jump('/other/distribution', { active: 'location', locationId: scope.row.locationId })">{{ $t('location.fen_pei_she_bei') }}</el-button>
            <el-button type="text" size="mini" v-if="funcView.location_plan_add"  @click.stop="addPlan(scope.row)">{{ $t('location.pai_ban_ji_hua') }}</el-button>
            <el-button type="text" size="mini" v-if="funcView.location_edit" @click.stop="editLocation(scope.row)">{{ $t('Common.com_edit') }}</el-button>
            <el-button type="text" size="mini" v-if="funcView.location_delete && scope.row.deviceNum == 0" @click.stop="deleteLocation(scope.row)">{{ $t('Common.com_delete') }}</el-button>
          </template>
        </custom-table>
      </div>

      <div class="table-footer">
        <custom-pagination radius :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
      </div>
    </div>
    <!-- <div class="table-bd">
      <ul class="table-head">
        <li class="project">
          <span class="project-th">项目名称</span>
        </li>
        <li class="person">
          <span>负责人</span>
        </li>
        <li class="address">
          <span>项目地址</span>
        </li>
        <li class="person">
          <span>目标-清洁面积</span>
        </li>
        <li class="person">
          <span>目标-清洁时长</span>
        </li>
        <li class="num">
          <span>允许自动更新</span>
        </li>
        <li class="num">
          <span>设备数量</span>
        </li>
        <li class="action"></li>
      </ul>
      <ul class="table-body">
        <template v-if="tableList.length > 0">
          <li class="line" v-for="item in tableList" :key="item.locationId">
            <ul class="content" @click="jumpArea(item.locationId)">
              <li class="project">
                <div class="project-info">
                  <i class="icon icon-xiangmu"></i>
                  <div class="text">
                    <p>{{ item.locationName || '-' }}</p>
                    <span v-if="item.tagName">{{ item.tagName }}</span>
                  </div>
                </div>
              </li>
              <li class="person">
                <span>{{ item.contactName|| '-'  }}</span>
                <span style="margin-left: 4px">{{ item.contactPhone }}</span>
              </li>
              <li class="address">
                <span>{{ item.country }} {{ item.province }} {{ item.city }}{{ item.detailAddress }}</span>
              </li>

              <li class="person">
                <span>{{  `${$formatLenLocal(item.goalArea)} ${$formatLenUnit()}` || '-' }} </span>
              </li>
              <li class="person">
                <span>{{item.goalTime|| '-'}} min</span>
              </li>
              <li class="num">
                <span>{{ getDicValue('isynergy_cloud_bool', item.isBasicGoal )  }}</span>
              </li>
              <li class="num">
                <span>{{ item.deviceNum || '0' }}</span>
              </li>
              <li class="action">
                <el-button type="text" size="mini" v-if="funcView.location_assign" @click.stop="jump('/other/distribution', { active: 'location', locationId: item.locationId })">分配设备</el-button>
                <el-button type="text" size="mini" v-if="funcView.location_edit" @click.stop="editLocation(item)">编辑</el-button>
                <el-button type="text" size="mini" v-if="funcView.location_delete && item.deviceNum > 0" @click.stop="deleteLocation(item)">删除</el-button>
                <i class="link icon icon-you"></i>
              </li>
            </ul>
          </li>
        </template>
        <template v-else>
          <li class="no-data">暂无数据</li>
        </template>
      </ul>
    </div>
    <div class="table-footer">
      <custom-pagination radius :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
    </div> -->
    <location-plan-dialog v-if="dialogVisible3" :model="dialogModel3" @close="dialogVisible3 = false" @success="onItemChange"></location-plan-dialog>
    <location-item-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onItemChange"></location-item-dialog>
    <location-tag-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @success="onPageChange({ page: 1 })"></location-tag-dialog>
    <location-timeZone-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2= false"  @success="onPageChange({ page: 1 })"></location-timeZone-dialog>

  </div>
</template>

<script>
import apis from '@/utils/apis';
import locationPlanDialog from './children/location_plan_dialog.vue';
import locationItemDialog from './children/location_item_dialog.vue';
import locationTagDialog from './children/location_tag_dialog.vue';
import locationTimeZoneDialog from './children/location_timeZone_dialog.vue';

export default {
  name: 'location',
  components: { locationPlanDialog, locationItemDialog, locationTagDialog, locationTimeZoneDialog },
  watch: {
    'userInfo.rootOrgId': {
      handler(val) {
        if (val) {
          this.getTableList();
          // this.getLocationTagList();
        }
      },
      immediate: true,
    },
  },

  data() {
    return {
      tableSelect: [],
      isEditTag: false,
      totalRows: null,
      formSearch: {
        search: '',
        pageNum: 1,
        pageSize: 50,
        orgId: '',
        tagId: '',
        orgName: '',
        contactName: '',
        departmentId: '',
        departmentName: '',
        showSubsidiary: '',
      },
      departmentList: [],
      tableList: [],
      tagList: [],
      // 项目
      dialogVisible: false,
      dialogModel: {},
      // 标签
      dialogVisible1: false,
      dialogModel1: {},
      // 项目时间
      dialogVisible2: false,
      dialogModel2: {},
      dialogVisible3: false,
      dialogModel3: {},

      isFilter: false,
      timeZoneList: [],
    };
  },
  computed: {
    // 使用 computed 判断是否存在 isBasicGoal 为 true 的项
    hasBasicGoal() {
      return this.tableSelect.some(item => `${item.isBasicGoal}` === '1');
    },
    hasNoBasicGoa() {
      return this.tableSelect.some(item => `${item.isBasicGoal}` === '0');
    }
  },
  mounted: function () {
    // this.getTableList();
    // this.getLocationTagList();
    this.getFuncView();
    this.getTimeZoneList();
  },
  methods: {
    departmentTreeFilter(obj) {
      const ret = [obj];
      const ret2 = this.removeEmptyChildren(ret);
      return ret2;
    },
    removeEmptyChildren(nodes) {
      return nodes.map((item) => {
        // 如果 children 存在且是空数组，则删除 children 属性
        if (Array.isArray(item.children) && item.children.length === 0) {
          const newItem = { ...item }; // 创建一个新的对象，避免直接修改原数据
          delete newItem.children; // 删除 children 属性
          return newItem; // 返回没有 children 属性的对象
        }

        // 如果有子节点，递归调用 removeEmptyChildren
        if (item.children && item.children.length > 0) {
          return { ...item, children: this.removeEmptyChildren(item.children) };
        }

        return item; // 其他情况直接返回
      });
    },
    onDepartmentList(list) {
      this.departmentList = list;
    },

    // 自定义汇总方法
    summaryMethod({ columns, data }) {
      const sums = [];
      // 第一列，总计
      sums[0] = this.$t('location.zong_ji');
      // 第二列，deviceNum 的合计
      sums[1] = this.formatNumber(data.reduce((sum, row) => sum + (Number(row.deviceNum) || 0), 0));
      // 第四列，deviceNum * goalArea 的合计
      sums[4] = this.formatNumber(data.reduce((sum, row) => sum + (Number(row.deviceNum) || 0) * (Number(this.$formatLenLocal(row.basicArea)) || 0), 0));
      // 第五列，deviceNum * goalTime 的合计
      sums[5] = this.formatNumber(data.reduce((sum, row) => sum + (Number(row.deviceNum) || 0) * (Number(row.basicTime) || 0), 0));

      // 返回汇总行
      columns.forEach((column, index) => {
        if (index !== 0 && index !== 1 && index !== 4 && index !== 5) {
          sums[index] = ''; // 对其他列为空
        }
      });

      return sums;
    },

    // 格式化数字，判断是否保留两位小数
    formatNumber(number) {
      return number % 1 === 0 ? number : number.toFixed(2);
    },
    onItemChange(item) {
      if (`${item.isBasicGoal}` === '1' && this.funcView.location_update_targets) {
        this.$postJSON(apis.locationBasicGoalRefresh, [item.locationId]).then(() => {
          this.onPageChange({ page: 1 });
        });
      } else {
        this.onPageChange({ page: 1 });
      }
    },
    // 获取表格数据
    getTableList: function () {
      this.formSearch.orgId = this.userInfo.rootOrgId;
      this.formSearch.showSubsidiary = this.showSubsidiary;
      this.$getJSON(apis.locationPage, { ...this.formSearch, departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '' }).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 获取标签数据
    getLocationTagList: function () {
      this.formSearch.orgId = this.userInfo.rootOrgId;
      this.$getJSON(apis.locationTagList, { ...this.formSearch, departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '' }).then((res) => {
        this.tagList = res.data;
      });
    },
    changTagId(tagId = '') {
      if (!this.isEditTag) {
        this.formSearch.tagId = tagId;
        this.getTableList();
      }
    },
    // 新增计划
    addPlan(row) {
      this.dialogVisible3 = true;
      this.dialogModel3 = {
        type: 'add',
        title: this.$t('location.xin_zeng_ji_huao', [row.locationName]),
        data: { ...row }
      };
    },
    // 项目
    addLocation() {
      this.dialogVisible = true;
      this.dialogModel = {
        type: 'add',
        title: this.$t('location.xin_zeng_xiang_mu'),
      };
    },
    editLocation(row) {
      this.dialogVisible = true;
      this.dialogModel = {
        type: 'edit',
        title: this.$t('location.bian_ji_xiang_mu'),
        id: row.locationId,
        // data: row
      };
    },
    deleteLocation({ locationId }) {
      this.$showConfirm(this, this.$t('location.nqdyscxzdxmm'))
        .then(() => {
          this.$postJSON(`${apis.locationDelete}/${locationId}`).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: this.$t('Common.com_handle_success'),
                type: 'success',
              });
              this.getTableList();
            }
          });
        })
        .catch(() => {});
    },
    onRowClick(row) {
      // this.jumpArea(row.locationId);
      this.$emit('onArea', row.locationName);
    },
    jumpArea(locationId) {
      if (this.funcView.location_area_list) {
        this.jump('/other/location/accountLocationArea', { locationId: locationId });
      }

    },
    // 标签
    addTag() {
      this.dialogVisible1 = true;
      this.dialogModel1.title = this.$t('location.xin_zeng_biao_qian');
      this.dialogModel1.type = 'add';
      this.dialogModel1.data = {
        orgId: this.userInfo.rootOrgId,
        orgName: this.userInfo.rootOrgName,
        // ...data
      };
    },
    editTag(item) {
      this.dialogVisible1 = true;
      this.dialogModel1 = {
        title: this.$t('location.bian_ji_biao_qian'),
        type: 'edit',
        data: item,
      };
    },
    deleteTag({ tagId }) {
      this.$showConfirm(this, this.$t('location.nqdyscxzdbqm'))
        .then(() => {
          this.$postJSON(`${apis.locationTagDelete}/${tagId}`).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getLocationTagList();
          });
        })
        .catch(() => {});
    },
    // 获取时区列表
    getTimeZoneList: function () {
      this.$getJSON(apis.timeZoneGetCompanyList).then((res) => {
        this.timeZoneList = res.data;
      });
    },
    // 更新自动目标
    onUpdateTargets: function () {
      const title = this.$t('location.nqdyaxttjdxxzxmdmbzm');
      const ids = this.tableSelect.map(item => item.locationId);
      this.$showConfirm(this, title)
        .then(() => {
          this.$postJSON(apis.locationBasicGoalRefresh, ids).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_handle_success'),
            });
            this.onPageChange({ page: 1 });
          });
        })
        .catch(() => {});
    },
    onUpdateTimeZone() {
      this.dialogModel2.type = 'update';
      this.dialogModel2.title = this.$t('location.plgxxmsq');
      this.dialogModel2.data = this.tableSelect;
      this.dialogVisible2 = true;
    },
    // 启用目标自动设置
    onEnableTargets: function () {
      const title = this.$t('location.nqdyqyzdgxmbzsxxmm');
      const ids = this.tableSelect.map(item => item.locationId);
      this.$showConfirm(this, title)
        .then(() => {
          this.$postJSON(`${apis.locationBasicGoalAutoBatch}/1`, ids).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_handle_success'),
            });
            this.onPageChange({ page: 1 });
          });
        })
        .catch(() => {});
    },
    // 禁用目标自动设置
    onDisableTargets: function () {
      const title = this.$t('location.nqdyjyzdgxmbzsxxmm');
      const ids = this.tableSelect.map(item => item.locationId);
      this.$showConfirm(this, title)
        .then(() => {
          this.$postJSON(`${apis.locationBasicGoalAutoBatch}/0`, ids).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_handle_success'),
            });
            this.onPageChange({ page: 1 });
          });
        })
        .catch(() => {});
    },
    onDepartmentLabel(Label) {
      this.formSearch.departmentName = Label;
    },
    onClear() {
      this.formSearch.orgName = '';
      this.formSearch.contactName = '';
      this.formSearch.departmentId = '';
      this.formSearch.departmentName = '';
      this.onPageChange({ page: 1 });
    },
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.isEditTag = false;
      this.getTableList();
      this.getLocationTagList();
    },
    // 导出
    onExport: function () {
      this.formSearch.showSubsidiary = this.showSubsidiary;
      this.exportTable('locationExport', { ...this.formSearch, departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '', excludeColumnList: this.timeZoneList.length > 1 ? [] : ['timeZoneRegionDesc'] });
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';
.location-bd {
  .search-hd {
    padding: 24px;
    // height: 90px;
    /* 字体色/#FFFFFF */
    background: #ffffff;
    border-radius: 16px;
    .title-hd {
      font-weight: bold;
      font-size: 18px;
      line-height: 40px;
      margin-bottom: 24px;
      /* 字体色/$--color-text-primary */
      color: $--color-text-primary;
      .icon {
        font-size: 20px;
        color: $--color-text-primary;
        margin-right: 12px;
      }
    }
    .form-screen {
      // height: 40px;
      // display: flex;
      // align-items: flex-start;
      .el-form-item{
        margin-bottom: 0;
      }
      .tag-item {
        flex: 1;
        width: 0;
        .el-form-item__content {
          width: 100%;
        }
        .item-tag {
          // height: 40px;
          line-height: 40px;
          display: flex;
          align-items: flex-start;

          // max-width: 520px;
          // overflow: auto;
          .lable {
            align-items: center;
            font-weight: bold;
            font-size: 14px;
            line-height: 140%;
            color: $--color-text-secondary;
            margin-right: 8px;
            margin-top: 8px;
          }
          .tag-list {
            display: flex;
            flex-direction: row;
            // align-items: center;
            flex: 1;
            flex-wrap: wrap;
            // overflow-x: auto;
            margin-right: 8px;
            .tag {
              height: 30px;
              color: #1a1a1a;
              background: #f8f8f8;
              padding: 0 16px;
              background: #f8f8f8;
              line-height: 30px;
              margin-right: 8px;
              margin-bottom: 8px;
              border-radius: 100px;
              cursor: pointer;
              flex: none;
              .name {
                margin-right: 4px;
              }
              .icon {
                font-size: 12px;
                color: $--color-primary;
                margin-left: 11px;
              }

              &.active {
                color: #ffffff;
                background: $--color-primary;
              }
            }
          }

          .icon-shezhi,
          .icon-guanbi1,
          .icon-tianjia {
            width: 40px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            font-size: 14px;
            color: $--color-text-primary;
            border-radius: 100px;
            background-color: $--color-warning;
            margin-right: 8px;
            cursor: pointer;
          }

          .icon-tianjia {
            color: $--color-primary;
            background-color: #f8f8f8;
          }
        }
      }
      .icon-filter {
        display: inline-block;
        text-align: center;
        box-sizing: border-box;
        font-size: 14px;
        width: 40px;
        height: 40px;
        color: $--color-text-primary;
        box-shadow: 0 0 0 1.5px #202945 inset;
        border-radius: 50px;
        cursor: pointer;
      }
    }
  }

  // 表格
  // .table-bd {
  //   margin-top: 24px;
  //   width: 100%;
  //   // 表头
  //   .table-head {
  //     height: 52px;
  //     line-height: 52px;
  //     display: flex;
  //     background-color: #fff;
  //     border-radius: 16px;
  //     li {
  //       padding-left: 10px;
  //       // text-align: center;
  //       color: $--color-text-secondary;
  //       box-sizing: border-box;
  //       overflow: hidden;
  //       text-overflow: ellipsis;
  //       white-space: nowrap;
  //       span {
  //         font-weight: bold;
  //         font-size: 14px;
  //         color: $--color-text-secondary;
  //       }
  //       &.project {
  //         .project-th {
  //           padding-left: 66px;
  //           text-align: left;
  //         }
  //       }
  //     }
  //   }
  //   // 内容
  //   .table-body {
  //     // height: 80px;
  //     // line-height: 80px;

  //     // align-content: center;
  //     .content {
  //       cursor: pointer;
  //       margin-top: 16px;
  //       height: 80px;
  //       line-height: 80px;
  //       display: flex;
  //       // flex-direction: column;
  //       background-color: #fff;
  //       border-radius: 16px;
  //       align-content: center;
  //       font-size: 14px;
  //       li {
  //         box-sizing: border-box;
  //         padding-left: 10px;
  //         font-size: 14px;
  //         color: $--color-text-secondary;
  //         white-space: nowrap; //不换行
  //         overflow: hidden; //超出隐藏
  //         text-overflow: ellipsis; //变成...
  //         // text-align: center;
  //         span {
  //           font-size: 14px;
  //           color: #1a1a1a;
  //         }
  //       }
  //     }
  //     // 无数据
  //     .no-data {
  //       margin-top: 24px;
  //       height: 130px;
  //       text-align: center;
  //       line-height: 130px;
  //       font-size: 16px;
  //       color: #818181;
  //       background: #ffffff;
  //       border-radius: 16px;
  //     }
  //   }
  //   // 列占比
  //   .project {
  //     width: 0;
  //     flex: 6;
  //     .project-info {
  //       padding-left: 25px;
  //       height: 80px;
  //       display: flex;
  //       align-items: center;
  //       font-size: 0;
  //       i {
  //         color: $--color-primary;
  //         font-size: 22px;
  //         margin-right: 18px;
  //       }
  //       .text {
  //         align-self: center;
  //         display: flex;
  //         // align-items: center;
  //         flex-direction: column;
  //         p {
  //           font-weight: bold;
  //           font-size: 14px;
  //           line-height: 20px;
  //           color: $--color-text-regular;
  //         }
  //         span {
  //           font-size: 12px;
  //           line-height: 17px;
  //           text-align: left;
  //           color: $--color-text-secondary;
  //         }
  //       }
  //     }
  //     // width: 330px;
  //   }
  //   .person {
  //     // width: 292px;
  //     width: 0;
  //     flex: 3;
  //     // width: 200px;
  //     text-align: left !important;
  //   }
  //   .address {
  //     width: 0;
  //     flex: 6;
  //     text-align: left !important;
  //   }
  //   .num {
  //     width: 0;
  //     flex: 2;
  //     text-align: center;
  //     padding: 0 !important;
  //     margin-right: 30px;
  //   }
  //   .action {
  //     width: 0;
  //     flex: 5;
  //     // width: 300px;
  //     text-align: left !important;
  //     display: flex;
  //     button {
  //       margin-right: 24px;
  //     }
  //     span {
  //       color: $--color-primary !important;
  //     }
  //     i {
  //       margin-left: auto;
  //       margin-right: 40px;
  //       font-size: 14px;
  //       color: #7b7f93;
  //       cursor: pointer;
  //     }
  //   }
  // }

  .table-bd {
    height: 450px;
  }
  .table-footer {
    height: 88px;
  }
}
</style>
